import "./PatientsList.scss";
import { List, Typography, Badge, Button, Breadcrumb, Image } from "antd";
import { CaretUpOutlined } from "@ant-design/icons";
import patientImage from "../../assets/default_image_patient.png";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import Utils from "../../utils";

export default function PatientsList({
  patients = [],
  loading,
  onListItemClick,
  handlePatientUpvote,
  token,
}) {
  const { width, isMobile } = useWindowDimensions();

  return (
    <List
      className="patientList-cont"
      dataSource={Utils?.madeUnique(patients)}
      loading={loading}
      size="small"
      itemLayout="vertical"
      renderItem={(patient) => (
        <List.Item
          key={patient?.id}
          className="patientList-cont__item"
          style={{
            cursor: "pointer",
          }}
          styles={{
            actions: {
              marginLeft: "0px",
            },
            extra: {
              marginTop: "0px",
              marginLeft: "8px",
            },
          }}
          onClick={() => {
            onListItemClick(patient);
          }}
          extra={
            <Badge
              size="small"
              color={token?.colorSecondaryLogo}
              count={patient?.upvotes ? patient?.upvotes : 0}
              styles={{
                root: {
                  marginRight: "15px",
                  marginTop: "5px",
                },
              }}>
              <Button
                size={isMobile ? "small" : "middle"}
                icon={
                  <CaretUpOutlined
                    style={{
                      fontSize: "18px",
                    }}
                  />
                }
                onClick={(e) => {
                  e.stopPropagation();
                  handlePatientUpvote(patient);
                }}
              />
            </Badge>
          }>
          <List.Item.Meta
            className="patientList-cont__item__meta"
            avatar={
              <div
                onClick={(e) => {
                  e.stopPropagation(); // Prevent List.Item's onClick from being triggered
                }}>
                <Image
                  style={{
                    width: "40px",
                    height: "50px",
                  }}
                  src={
                    patient?.id_image_url ? patient?.id_image_url : patientImage
                  }
                  alt="p_img"
                />
              </div>
            }
            title={
              <Typography.Text
                strong
                ellipsis={
                  isMobile && width <= 350
                    ? {
                        tooltip: {
                          title: `${
                            patient?.first_name ? patient?.first_name : ""
                          }
                      ${patient?.last_name ? patient?.last_name : ""},
                      ${
                        patient?.email ? Utils?.safe_mask_email(patient?.email) : ""
                      }`,
                        },
                      }
                    : null
                }>
                {`${patient?.first_name ? patient?.first_name : ""}
                      ${patient?.last_name ? patient?.last_name : ""},
                      ${
                        patient?.email ? Utils?.safe_mask_email(patient?.email) : ""
                      }`}
              </Typography.Text>
            }
            description={
              <div
                style={{
                  cursor: "auto",
                  width: "fit-content",
                }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevent List.Item's onClick from being triggered
                }}>
                <Breadcrumb
                  separator="•"
                  items={[
                    {
                      title: patient?.phone_number ? (
                        <Typography.Text type="secondary">
                          {Utils?.safe_mask_phone(patient?.phone_number)}
                        </Typography.Text>
                      ) : (
                        <Typography.Text type="secondary">
                          Phone
                        </Typography.Text>
                      ),
                    },
                    !isMobile
                      ? {
                          title: patient?.dob ? (
                            <Typography.Text type="secondary">
                              {Utils?.format_date(patient?.dob)}
                            </Typography.Text>
                          ) : (
                            <Typography.Text type="secondary">
                              Date Of Birth
                            </Typography.Text>
                          ),
                        }
                      : null,
                    {
                      title: patient?.address ? (
                        <a
                          href={`${Utils?.getUrlInMap(patient?.address)}`}
                          target="_blank"
                          rel="noopener noreferrer">
                          <Typography.Text
                            className="patientList-cont__item__meta__address"
                            ellipsis={{
                              tooltip: {
                                title: `${patient?.address}`,
                              },
                            }}
                            style={
                              isMobile && width > 350
                                ? {
                                    whiteSpace: "normal", // Allow line breaks between words
                                    overflowWrap: "break-word", // Ensure long words break properly
                                    display: "inline", // Ensure the ellipsis works with the text
                                  }
                                : null
                            }>
                            {patient?.address}
                          </Typography.Text>
                        </a>
                      ) : (
                        <Typography.Text type="secondary">
                          Address
                        </Typography.Text>
                      ),
                    },
                  ]?.filter((item) => item !== null)}
                />
              </div>
            }
          />
          <Typography.Text>
            {patient?.ban_reason ? patient?.ban_reason : "No Reason"}
          </Typography.Text>
        </List.Item>
      )}
    />
  );
}
